import React, { useEffect, useState } from 'react'
import {Row, Col, DatePicker, Form, Button, Input, Space, Checkbox, Select} from 'antd'
import SearchInput from 'components/SearchInput'
import moment from 'moment'
import localeUS from 'antd/es/date-picker/locale/en_US'
import localeAz from 'antd/es/date-picker/locale/az_AZ'
import localeRu from 'antd/es/date-picker/locale/ru_RU'
import CustomTooltip from 'components/Tooltip'
import SelectField from 'components/SelectField'
import { useActions } from '../../../hooks/useActions'
import { CloseIco, ErrorNotificationIco, SearchIco } from '../../../../modules/CustomIcons'
import { setTableData } from 'store/actions/transfers'
import { setIbanNumber } from 'store/actions/accountStatement';
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import InputField from 'components/InputField'


const TransfersFilter: React.FC<any> = (props) => {
  const {t} = useTranslation()
  const [form] = Form.useForm()
  const dateFormat = 'DD.MM.YYYY'

  // let splitted = props.businessDate.split('.')  
  // let newDate = splitted[1] + '.' +  splitted[0] + '.' + splitted[2]
  const { setTableData, setIbanNumber } = useActions()

  const [diff, setDiff] = useState(false)
  const [account, setAccount] = useState('')
  const [batchChecked, setBatchCheck] = useState(false)
  const [status, setStatus] = useState('')
  const [startDate, setStartDate] = useState(props.startDate)
  const [endDate, setEndDate] = useState(props.endDate)
  const [defeaultEndDate, setDefaultEndDate] = useState(props.businessDate)
  const [searchValue, setValue] = useState('')
  const [activeDateIndex, setActiveDateClass] = useState(1)
  const [selected, setSelected] = useState(false)
  const [openStatus, setOpenStatus] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState(props.packages)
  let locale;
  if(localStorage.getItem('i18nextLng')==='az'){
    locale = localeAz
  }else if(localStorage.getItem('i18nextLng')==='en'){
    locale= localeUS
  }else if(localStorage.getItem('i18nextLng')==='ru'){
    locale= localeRu
  }
  const dateFilters = [
    {
      key: 1,
      label: t("transfers.today"),
      dateFrom: moment(),
      dateTo: moment(props.businessDate, dateFormat)
    },
    {
      key: 2,
      label: t("transfers.yesterday"),
      dateFrom: moment().add(-1, 'days'),
      dateTo: moment().add(-1, 'days'),
    },
    {
      key: 3,
      label: t("transfers.thisWeek"),
      dateFrom: moment().startOf('week').add(1, 'days'),
      dateTo: moment(props.businessDate, dateFormat),
    },
    {
      key: 4,
      label: t("transfers.lastWeek"),
      dateFrom: moment().subtract(1, 'weeks').startOf('week').add(1, 'days'),
      dateTo: moment().subtract(1, 'weeks').endOf('week').add(1, 'days'),
      // dateTo: moment().subtract(1, 'weeks').endOf('week').add(1, 'days'),
    },
    {
      key: 5,
      label: t("transfers.thisMonth"),
      dateFrom: moment().startOf('month'),
      dateTo: moment(props.businessDate, dateFormat),
    },
    {
      key: 6,
      label: t("transfers.lastMonth"),
      dateFrom: moment().subtract(1, 'months').startOf('month'),
      dateTo: moment().subtract(1, 'months').endOf('month')
      //dateTo: moment()
    }
  ]

  useEffect(()=>{
    setFilteredOptions(props.packages)
  },[props.packages])

  useEffect(() => {
    setStartDate(props.startDate)
    setEndDate(props.endDate)
    form.setFieldsValue({ startDate: props.startDate, endDate: props.endDate });
  }, [props.startDate, props.endDate])

  const handleAccount = (value: any) => {
    setAccount(value)
  }

  const handleStatus = (value: string) => {
    setStatus(value)
  }

  const handleSearch = (e: any) => {
    setValue(e.target.value)
  }

  const removeSearch = () => {
    form.resetFields(["input_"]);
    setValue('')
  }

  const handleSearchBatch = (searchValue) =>{
    const filtered = props.packages.filter(option =>
      option.label.toLowerCase().includes(searchValue.toLowerCase())
    );
    setFilteredOptions(filtered)
  } 

  const handleStartDate = (date: any, dateString: string) => {
    // setActiveDateClass(0)
    setStartDate(date)
    props.handleDateFilter()
  }

  const handleEndDate = (date: moment, dateString: string) => {
    setEndDate(date)
    props.handleDateFilter()
    // setActiveDateClass(0)
  }

  useEffect(() => {
    if (props?.buttonClickedTriggerChild !== undefined && props?.buttonClickedTriggerChild !== 0) {
      TriggeredFunc()
    }
  }, [props?.buttonClickedTriggerChild])

  const TriggeredFunc = () => {
    form.submit();
  }

  const handleFilter = (values: any) => {
    
    console.log(values)
    if (!diff) {
      setTableData(values)
      props.handleFilter(values)
    }
  }

  useEffect(() => {
    const diff = moment(endDate).isSameOrAfter(moment(startDate), 'date')
    setDiff(!diff)
  }, [startDate, endDate])

  const handleDateFilterData = (key: number, dateFrom: Date, dateTo: Date) => {
    // setActiveDateClass(key)
    setStartDate(moment(dateFrom))
    setEndDate(moment(dateTo))
    form.setFieldsValue({ startDate: dateFrom, endDate: dateTo });
    props.handleDateData(key)
    // props.handleDateFilter(key, dateFrom, dateTo)
  }

  useEffect(() => {
    setAccount(props?.ibanNumber.iban ?? "")
    setIbanNumber({ iban: undefined })
  }, [])
  const onChange = (e: any) => {
    setBatchCheck(e.target.checked);
    if(!e.target.checked){
      
      form.setFieldsValue({"batchName":undefined})
    }else{
      
      form.setFieldsValue({"batchName":'all'})
    }
    
  };

  const onDropdownVisibleChange = (open) => {

    setOpenStatus(open)
    if (open) {
      setSelected(false)
      setTimeout(() => {
        document.querySelector('.ant-select-item.ant-select-item-option')?.classList.remove('ant-select-item-option-active');
      });
    }
  }
  // @ts-ignore
  return (
    <>
      <Row className="transfers__filter transfers__filter--scroll">
        <Form
          className='flex fullWidth transferFormFilter'
          form={form}
          onFinish={handleFilter}
        >
          <Col className="second__column">
            <div className="pickers flex">
              <label>{t("transfers.period")} </label>
              <div
                className="pickers__width flex"
                style={{ width: '287px', position: 'relative', height: 40 }}
              >
                <div>
                  <Form.Item name='startDate'>
                    <DatePicker
                      // open={false}
                      // showTime={this.state.showAndHideShowTime}
                      style={{ float: 'left' }}
                      locale={locale}
                      defaultValue={moment(moment(startDate), dateFormat)}
                      className={diff ? 'errored-ant-picker' : ''}
                      onChange={handleStartDate}
                      suffixIcon={null}
                      value={moment(startDate).format(dateFormat)}
                      format={dateFormat}
                      allowClear={false} />
                  </Form.Item>
                  {diff && (
                    <CustomTooltip
                      className="error-tooltip"
                      trigger="hover"
                      title={t("transfers.startDateCantBeLaterThanEndDate")}
                    >
                      <div className="error-tooltip__icon error-tooltip__icon--left bt-44">
                        <ErrorNotificationIco />
                      </div>
                    </CustomTooltip>
                  )}
                </div>
                <span style={{ margin: 'auto 10px' }}>-</span>
                <div>
                  <Form.Item name='endDate'>
                    <DatePicker
                      locale={locale}
                      style={{ float: 'right' }}
                      defaultValue={defeaultEndDate}
                      className={diff ? 'errored-ant-picker' : ''}
                      onChange={handleEndDate}
                      value={moment(endDate).format(dateFormat)}
                      suffixIcon={null}
                      format={dateFormat}
                      allowClear={false} />
                  </Form.Item>
                  {diff && (
                    <CustomTooltip
                      // visible
                      className="error-tooltip"
                      trigger="hover"
                      title={t("transfers.startDateCantBeLaterThanEndDate")}
                    >
                      <div className="error-tooltip__icon error-tooltip__icon--right bt-44">
                        <ErrorNotificationIco />
                      </div>
                    </CustomTooltip>
                  )}
                </div>
              </div>
            </div>
            <ul className="dates-list flex">
              {dateFilters.map((item, index) => {
                return <li className={(index + 1) == props.activeDateIndex ? 'active' : ''}><p onClick={() => {
                  handleDateFilterData(item.key, item.dateFrom, item.dateTo);
                  handleFilter(form.getFieldsValue(['startDate','endDate','account','status','filter','batchName','batchChecked']))
                }}>{item.label}</p></li>
              })}
            </ul>
          </Col>
          <Col span={7} className="column__middle mobile-select">
            <div className="">
              <SelectField
                name='account'
                labelItem={t("transfers.fromAccount")}
                // open={true}
                placeholder={t("common.all")}
                onChange={(args: any) => handleAccount(args)}
                value={account}
                options={props.selectAccountOptions}
                dropdownClassName="transfers-dropdown"
                // placeholder="Bütün"
                optionLabelProp="label"
                label
                className="labelNoDots filter-select"
                defaultValue={props.ibanNumber.iban}
                width={300}
                transfer={true}
              />

              <SelectField
                name='status'
                labelItem={t("credits.creditStatus")}
                // open={true}
                options={props.selectStatusOptions}
                onChange={(args: any) => handleStatus(args)}
                value={status}
                label
                placeholder={t("common.all")}
                className="labelNoDots filter-select"
                width={300} />
            </div>
          </Col>


          <Col className='third_column mobile-select'>
            <div className="transfers_search_Panel  " >
              <Space direction="vertical">
                  
                <Form.Item >
                  <Checkbox 
                  name='batchChecked'
                  checked={batchChecked}
                  onChange={onChange}
                  >
                    {t("transfers.uploadedbybatch")}
                  </Checkbox> 
                  {/* {console.log(props.packages)} */}
                  {/* <Select
                  showSearch
                disabled={!batchChecked} 
                placeholder={t("transfers.allPackets")}
                style={{ width: "max-content" }}
                // labelInValue
                optionLabelProp='label'
                notFoundContent={t("notification.notFoundInfo")}
                onChange={(value: string) => null}
              >
                {

props.packages?.map((row: any, index: number) => {

                    return (
                      <Option key={index} value={row.value} >

                        <div
                        >
                          {<span className={'asdfg'}>
                            {!selected ? row.label : row.value}
                          </span>

                          }
                        </div>
                        {row.extra && (openStatus) && value !== row.value && <span>{row.extra}</span>}
                      </Option>
                    )
                  })
                }
              </Select> */}
                  <SelectField
                    id="batchName-select"
                    showSearch
                    notFoundContent={t("notification.notFoundInfo")}
                    name={'batchName'}
                    options={filteredOptions}
                    filterOption={false}
                    onSearch={handleSearchBatch}
                    disabled={!batchChecked} 
                    placeholder={t("transfers.allPackets")}
                    width={295}
                  />
                </Form.Item>
                <Form.Item className={'flex search_transferInput'} name='filter' label={t("transfers.searchBy")} >
                  <InputField
                  form={form}
                    placeholder={searchValue === '' ? t("transfers.atLeast3Char") : searchValue}
                    onChange={handleSearch}
                    // allowClear={false}
                    value={searchValue}
                    maxLength={160}
                    width={185}
                    suffix={
                      !searchValue ?
                        <Button ghost className="searchIcon"
                          icon={<SearchIco />} />
                        : <Button ghost className='clear-icon custom-closeTransfer' onClick={removeSearch}
                          icon={<CloseIco />} />
                    }
                    className="not-required search-field labelNoDots transfer_search_input"
                    required={false}
                    
                  />
                  <Button style={{bottom:7, width: '200px !important'}} htmlType="submit" className="blue-button transfers_search_Button">{t("transfers.search")}</Button>

                </Form.Item>
              </Space>



            </div>
          </Col>

        </Form>
      </Row></>
  )
}
const mapDispatchToProps = { setTableData, setIbanNumber }

const mapStateToProps = (state: any) => ({
  ibanNumber: (state.accountsStatement && state.accountsStatement.ibanNumber) ? state.accountsStatement.ibanNumber : {}
})

export default connect(mapStateToProps, mapDispatchToProps)(TransfersFilter)

